import { getTokenAccessInfo } from "../../utils/jwt";

// Admin kullanıcı tipini tanımla
export interface Admin {
  uid: string;
  email: string;
  admin: boolean;
  firebase_token?: string; // YENİ ALAN: Backend model değişikliği
}

export interface AuthResponse {
  success: boolean;
  user: Admin;
  token?: string;
}

export const isCurrentUserAdmin = async (): Promise<boolean> => {
  try {
    // Token claim'lerinden panel erişimini kontrol et
    const token = localStorage.getItem("authToken");
    if (!token) {
      return false;
    }

    const access = getTokenAccessInfo(token);

    return access.hasPanelAccess;
  } catch (_error: any) {
    return false;
  }
};

// Simple logout - sadece local token'ı temizle
export const logout = async (): Promise<void> => {
  try {
    localStorage.removeItem("authToken");
  } catch (_error) {
    localStorage.removeItem("authToken");
  }
};
